import {
  GET_USER_PROFILE_FAILED,
  GET_USER_PROFILE_REQUEST,
  GET_USER_PROFILE_SUCCESS,
  SET_TWO_FACTOR_STATUS,
  SET_NEED_TO_LINK_INITIATIVE,
  CONNECT_INNITITATIVE_REQUEST,
  CONNECT_INNITITATIVE_SUCCESS,
  CONNECT_INNITITATIVE_FAILED,
  SET_POST_AUTH_REDIRECT_URL,
  CLEAR_POST_AUTH_REDIRECT_URL,
} from './actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const getUserProfileRequest = () => ({ type: GET_USER_PROFILE_REQUEST });
export const getUserProfileSuccess = (user) => ({ type: GET_USER_PROFILE_SUCCESS, user });
export const getUserProfileFailure = () => ({ type: GET_USER_PROFILE_FAILED });

export const setTwoFactorStatus = (twoFactorStatus) => ({
  type: SET_TWO_FACTOR_STATUS,
  twoFactorStatus,
});

export const setNeedToLinkInitiative = (userIdForLinkNewInitiative) => ({
  type: SET_NEED_TO_LINK_INITIATIVE,
  userIdForLinkNewInitiative,
});

export const connectInititativeRequest = () => ({ type: CONNECT_INNITITATIVE_REQUEST });
export const connectInititativeSuccess = () => ({ type: CONNECT_INNITITATIVE_SUCCESS });
export const connectInititativeFailure = () => ({ type: CONNECT_INNITITATIVE_FAILED });

export const setPostAuthRedirectUrl = (url) => ({ type: SET_POST_AUTH_REDIRECT_URL, url });
export const clearPostAuthRedirectUrl = () => ({ type: CLEAR_POST_AUTH_REDIRECT_URL });
